import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CardInform } from "../../components/CardInform";
import imgCard from "../../images/email-em-analise.png";
import styles from "./styles.module.css";
import {
  Status,
  TipoCadastroPlanTrib,
  Token,
} from "../../utils/localStorage.util";
import axios from "axios";
import MensagemErro from "../../components/MensagemErro";
import { LoginContext } from "../../config/Context/LoginContext";
import config from "../../config";
import ChatAssincrono from "../../components/ChatAssincrono";

export const PropostaEmAnalise = () => {
  const { dadosLogin } = useContext(LoginContext);
  const pageName = "Proposta em análise!";
  const textDescription =
    "Estamos fazendo a análise da sua proposta e logo retornaremos no seu e-mail cadastrado.";

  const navigate = useNavigate();
  const [msg, setMsg] = useState("");

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      const tipoCadastroPlanTrib = dadosLogin.tipoCadastroPlanTribKey;
      const headers = {
        Authorization: Token.getToken(),
        "Content-Type": "application/json", // Exemplo de cabeçalho personalizado
      };
      const formData = {
        validacaoFront: true,
      };

      try {
        const response = await axios.post(
          `${config.REACT_APP_HOST_API_AUTENTICACAO}/usuarios/buscar-status-plan-trib/${tipoCadastroPlanTrib}`,
          formData,
          { headers: headers }
        );
        Status.setStatus(response.data.status);
        if (response.data.status !== "ANALISANDO") navigate("/dashboard");
      } catch (error) {
        setMsg(error.response.data.mensagem);
        handleOpenSnackbarErro();
      }
    };

    fetchData();
  });

  return (
    <div>
      <div className={styles.pageProposta}>
        <CardInform
          title="Sua proposta segue em análise!"
          description={textDescription}
          image={imgCard}
          imgAlt="Imagem para exemplificar analise"
        />
        <MensagemErro
          open={openSnackbarErro}
          handleClose={handleCloseSnackbarErro}
          msg={msg}
        />
      </div>
    </div>
  );
};
